import React from 'react'
import ImgMacBook from '../../assets/macbook.webp'

export default function TrustedPartnerships(props) {
    return (
        <section ref={props.sectionRef} id='projects' className="relative flex nav-sm:min-h-[100svh] bg-[#3E3E3E] TrustedPartnerships w-full overflow-hidden">
            <div className='w-full nav-sm:flex items-center justify-around mt-[70px]'>
                <div className='flex h-full w-full items-center justify-center'>
                    {/* Desktop image column. `relative flex items-center
                        justify-center hidden nav-sm:block` stacked four
                        conflicting display utilities on one element. */}
                    <div className='hidden nav-sm:block w-full nav-sm:w-[46%] relative mt-[70px]'>
                        <img src={ImgMacBook} alt="Gravisun on a MacBook" width={1024} height={1012} className='left-[-24px] max-h-[80vh] pb-2 nav-sm:pt-2' loading="lazy" />
                    </div>

                    <div className='flex flex-col justify-center w-full nav-sm:w-[54%] mt-[16%] nav-sm:mt-[5%]'>
                        {/* ONE copy block. It used to be duplicated per
                            breakpoint, which meant the same heading and two
                            paragraphs shipped twice in the rendered text. */}
                        <div data-reveal className='pl-[38px] md:pl-[62px] nav-sm:pl-[70px] c-lg:pl-[94px] pr-[24px] md:pr-[62px] nav-sm:pr-[50px]'>
                            <h2 className='text-36 md:text-42 c-lg:text-50 c-xl:text-60 text-white w-full font-bold nav-sm:pr-[100px] c-xl:pr-[120px]'>
                                ALL OF OUR PROJECTS ARE CONFIDENTIAL
                            </h2>
                            {/* Work Sans sets wider than the SF Pro this line
                                used to be typeset in, so it now takes two lines
                                at some widths. Balanced rather than left to
                                orphan the last word. */}
                            <p className='text-18 md:text-24 c-lg:text-32 c-xl:text-42 font-medium text-[#B4B4B4] mt-[22px] nav-sm:mt-[32px] c-lg:mt-[42px] text-balance'>
                                Your project and ideas are safe with us
                            </p>
                            <p className='text-16 md:text-18 c-lg:text-28 c-xl:text-30 text-[#B4B4B4] mt-[16px] c-md:mt-[22px] nav-sm:mt-[32px] c-lg:mt-[42px] pr-0 c-hd:pr-[60px]'>
                                We guarantee complete client confidentiality for as long as necessary, ensuring your privacy is maintained with the highest level of professionalism and discretion.
                            </p>
                        </div>

                        {/* Mobile image. `mb-[32]` had no unit, so Tailwind
                            emitted nothing for it. */}
                        <img src={ImgMacBook} alt="" aria-hidden="true" width={1024} height={1012} className='h-full block nav-sm:hidden mt-[38px] mb-[32px] w-[89%] c-md:w-[60%] macImage' loading="lazy" />
                    </div>
                </div>
            </div>

            <div className="absolute bg-colorSun sun sun-sm-bottom block nav-sm:hidden mt-[70px]" />
            <div className="absolute bg-colorSun sun sun-md-top-right-large hidden nav-sm:block mt-[40px]" />
        </section>
    )
}
